import { createFileRoute, redirect, useParams } from '@tanstack/react-router'

import { isLandingEnabled } from 'lib/landingFlag'
import { requireAuth } from 'lib/routeGuards'

import { LandingPage } from 'pages/Landing'

export const Route = createFileRoute('/industries/$slug')({
  beforeLoad: (args) => {
    if (isLandingEnabled()) {
      // Authenticated users go to their home page, not the marketing page
      if (args.context.auth.currentUser) {
        const home = args.context.auth.routing.home || '/search'
        throw redirect({ to: home })
      }
    } else {
      requireAuth(args)
    }
  },
  component: IndustryLandingPage,
})

function IndustryLandingPage() {
  const { slug } = useParams({ from: '/industries/$slug' })
  return <LandingPage slug={slug} />
}
